import React from 'react';
import { useQuery } from '@apollo/client';
import compose from 'lodash/fp/compose';
import { formatPrice } from '@catalogo/core-helpers/price';
import { withCustomer } from '@catalogo/core-connect/customer';
import { ToggleBuyTogether } from '@catalogo/service-americanas-product/src/payment/buy-together-vip.graphql';
import { getSuggestedPrice, getBuyTogetherPrice, getPayments } from '../helpers/payment-v2';
import { WithPaymentV2Props } from '../types';

export const withPaymentV2 = (Component: React.FC) => ({
  page,
  currentSku,
  history,
  customer,
  defaultPrice,
  product,
  ...parentProps
}: WithPaymentV2Props) => {
  const { data: buyTogetherData } = useQuery(ToggleBuyTogether);
  const offer = currentSku?.offers?.result?.[0];
  const salesPrice = offer?.salesPrice;
  const superCashbackConfig = {
    rate: page?.components?.['page-config']?.cashbackRate,
    value: page?.components?.['page-config']?.cashbackValue,
  };

  const discountProgressive = {
    quantityForDiscount: product?.skus?.[0]?.offers?.result?.[0]?.nextProgressiveDiscount?.quantity,
    priceUnit: product?.skus?.[0]?.offers?.result?.[0]?.nextProgressiveDiscount?.unit,
  };

  const { mainPayment } = getPayments({ offer, isFinance: customer?.finance, superCashbackConfig });
  const suggestedPrice = getSuggestedPrice(offer, mainPayment);

  const props = {
    salesPrice,
    mainPayment,
    international: offer?.currency === 'USD',
    buyTogetherPriceText: getBuyTogetherPrice(buyTogetherData, salesPrice),
    suggestedPrice,
    currentSku,
    history,
    discountProgressive,
    defaultPriceText: defaultPrice && `R$ ${formatPrice(defaultPrice)}`,
    ...parentProps,
  };

  return <Component {...props} />;
};

export default compose(withCustomer, withPaymentV2);
